import { ROUTES_MAP } from 'app/shared/utils/routes';

export interface ExternalIdDetectedError {
  error_code: 'external_id_detected';
  hash_id?: string;
  object_type?: string;
  exists_in_opensearch?: boolean;
  status?: number;
}

export const isExternalIdDetectedError = (
  e: unknown,
): e is ExternalIdDetectedError =>
  typeof e === 'object' &&
  e !== null &&
  'error_code' in e &&
  (e as ExternalIdDetectedError).error_code === 'external_id_detected';

export type ObjectType = 'entity' | 'instrument' | 'action_event' | 'txn_event';

const OBJECT_TYPE_LABELS: Record<ObjectType, string> = {
  entity: 'entity',
  instrument: 'instrument',
  action_event: 'action event',
  txn_event: 'transaction',
};

export const getObjectTypeLabel = (
  objectType: string | undefined,
): string | undefined =>
  objectType ? (OBJECT_TYPE_LABELS[objectType] ?? objectType) : 'resource';

export const OBJECT_TYPE_TO_ROUTE: Record<string, (hashId: string) => string> =
  {
    entity: (hashId) => ROUTES_MAP.entitiesId.path.replace(':id', hashId),
    instrument: (hashId) =>
      ROUTES_MAP.instrumentsId.path.replace(':id', hashId),
    action_event: (hashId) =>
      ROUTES_MAP.dataExplorerActionEventsId.path.replace(':id', hashId),
    txn_event: (hashId) =>
      ROUTES_MAP.dataExplorerTransactionsId.path.replace(':id', hashId),
  };
